import _defineProperty from '../../node_modules/@babel/runtime/helpers/defineProperty.js';
import calculatePayment, { affordability, LOAN_TYPE } from '../../node_modules/@zillow/mortgage-calculations/dist/mortgage-calculations.esm.js';
import { SELF_REPORTED_CREDIT_OPTIONS_VALUES } from '../../constants.js';
import { OUTCOME } from './constants.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var affordabilityByDTI = affordability.affordabilityByDTI;
var LTV = 95;
var DTI = 36;
var MIN_LOAN_AMOUNT = 50000;
var MIN_CREDIT_SCORE = 620;
var MONTHLY_HOME_INSURANCE_CONSTANT = 0.00035;
var isHappyOutcome = function isHappyOutcome(outcome) {
  return [OUTCOME.ZHL_PREQUAL, OUTCOME.ZGMI_CQ].includes(outcome);
};
var determineOutcome = function determineOutcome(_ref) {
  var loanAmount = _ref.loanAmount,
    creditScore = _ref.creditScore,
    state = _ref.state;
  var creditScoreValues = SELF_REPORTED_CREDIT_OPTIONS_VALUES[creditScore];
  if (creditScoreValues.creditScoreHigh < MIN_CREDIT_SCORE) {
    return OUTCOME.LOW_CREDIT;
  } else {
    if (loanAmount >= MIN_LOAN_AMOUNT) {
      return (state === null || state === void 0 ? void 0 : state.toUpperCase()) === 'NY' ? OUTCOME.ZGMI_CQ : OUTCOME.ZHL_PREQUAL;
    }
    if (loanAmount < MIN_LOAN_AMOUNT) {
      return OUTCOME.HIGH_DEBT;
    }
  }
};
var calculateHomePriceBasedOnDownPayment = function calculateHomePriceBasedOnDownPayment(downPayment) {
  return downPayment / (1 - LTV / 100);
};
var calculateMonthlyHomeownersInsurance = function calculateMonthlyHomeownersInsurance(downPayment) {
  var assumedHomePrice = calculateHomePriceBasedOnDownPayment(downPayment);
  return assumedHomePrice * MONTHLY_HOME_INSURANCE_CONSTANT;
};
var calculateAffforability = function calculateAffforability(_ref2) {
  var annualIncome = _ref2.annualIncome,
    monthlyDebts = _ref2.monthlyDebts,
    downPayment = _ref2.downPayment,
    mortgageRate = _ref2.mortgageRate,
    propertyTaxRate = _ref2.propertyTaxRate,
    creditScore = _ref2.creditScore,
    state = _ref2.state;
  var monthlyHomeownersInsurance = calculateMonthlyHomeownersInsurance(downPayment);
  var inputs = {
    dti: DTI,
    annualIncome: annualIncome,
    monthlyDebts: monthlyDebts,
    downPayment: downPayment,
    rate: mortgageRate,
    term: 360,
    // 30 years fixed
    loanType: LOAN_TYPE.FIXED,
    propertyTaxRate: propertyTaxRate,
    includePropertyTax: true,
    annualHomeownersInsurance: monthlyHomeownersInsurance * 12,
    includeHomeownersInsurance: true,
    includePMI: true,
    includeTaxesInsurance: true
  };
  var _affordabilityByDTI = affordabilityByDTI(inputs),
    homePrice = _affordabilityByDTI.affordabilityByDTI,
    ltv = _affordabilityByDTI.ltv;
  var loanAmount = homePrice - downPayment;
  var paymentOutputs = calculatePayment(_objectSpread(_objectSpread({}, inputs), {}, {
    homePrice: homePrice
  }));
  var outcome = determineOutcome({
    loanAmount: loanAmount,
    creditScore: creditScore,
    state: state
  });
  return {
    homePrice: Math.floor(homePrice),
    ltv: ltv,
    loanAmount: loanAmount,
    lowerBoundHomePrice: homePrice * 0.95,
    upperBoundHomePrice: homePrice * 1.05,
    monthlyPayment: paymentOutputs === null || paymentOutputs === void 0 ? void 0 : paymentOutputs.monthlyPayment,
    monthlyPI: paymentOutputs === null || paymentOutputs === void 0 ? void 0 : paymentOutputs.monthlyPI,
    monthlyPropertyTax: paymentOutputs === null || paymentOutputs === void 0 ? void 0 : paymentOutputs.monthlyPropertyTax,
    monthlyHomeownersInsurance: monthlyHomeownersInsurance,
    monthlyPMI: paymentOutputs === null || paymentOutputs === void 0 ? void 0 : paymentOutputs.monthlyPMI,
    outcome: outcome,
    mortgageRate: mortgageRate,
    propertyTaxRate: propertyTaxRate
  };
};

export { calculateAffforability, calculateHomePriceBasedOnDownPayment, determineOutcome, isHappyOutcome };
//# sourceMappingURL=calculations.js.map
